/**
 * Default configuration for Home Page
 *
 * This configuration is used as the base for all clients
 * and can be overridden by client-specific config files.
 */

// Import default background image
import backgroundImage from 'assets/images/background-01.jpg';
import logoImage from 'assets/images/rd-logo-white.png';

export const defaultHomeConfig = {
  /**
   * Welcome message shown to users
   */
  welcomeMessage: 'Welcome to RadixDash',

  /**
   * Subtitle shown below welcome message
   */
  subtitle: 'Your AI-powered restaurant intelligence platform',

  /**
   * Body message in the content area
   */
  bodyMessage: 'Get started by exploring your dashboards and reports.',

  /**
   * Footer note about future enhancements
   */
  futurePhaseNote: 'Dashboard widgets and KPI summaries coming in Phase 1',

  /**
   * Header background image
   */
  headerBg: backgroundImage,

  /**
   * Logo image for identity bar
   */
  logo: logoImage,

  /**
   * Theme overrides (optional)
   */
  theme: {
    // Can be overridden by client-specific configs
  }
};

export default defaultHomeConfig;
